import Icon from 'vue-awesome/components/Icon'

Icon.register({
  perm_media_rounded: {
    paths: [
      {
        d: 'M1 6c-.55 0-1 .45-1 1v4h.01L0 20c0 1.1.9 2 2 2h17c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1zm21-2h-8l-1.41-1.41c-.38-.38-.89-.59-1.42-.59H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.6 14.2l3.51-4.68c.2-.26.59-.27.8-.01l3.1 3.99 2.1-2.53a.5.5 0 01.78.01l2.49 3.2a.5.5 0 01-.39.81H8a.491.491 0 01-.4-.79z'
      }
    ],
    width: '24',
    height: '24'
  }
})
